import * as angular from 'angular';
import {react2angular} from "react2angular";

import { Contract3d } from './components/Contract3d';

const contract3DModule = angular.module('dataforvalter.contract-3d', [])
    .component('react3d', react2angular(Contract3d, [], ['$routeParams', 'server', 'security', 'contract', 'nvdbapi']));
const modulename = contract3DModule.name;
export default modulename;

